import React from 'react';
import { Stack, type StackProps, styled } from '@mui/material';

interface RowItemFooterProps extends StackProps {
  children: React.ReactNode;
  customstyles?: any;
  isFullFooter?: boolean;
}

const LicenseStack = styled(Stack, {
  shouldForwardProp: prop => prop !== 'isFullFooter',
})<{ isFullFooter: boolean }>(({ theme, isFullFooter }) => ({
  flexDirection: 'row',
  borderBottom: '1px solid #d4d8e3',
  alignItems: 'flex-start',
  gap: '12px',
  padding: `16px 0 ${isFullFooter ? '16px' : 0}`,
  [theme.breakpoints.up('md')]: {
    alignItems: 'center',
    gap: '20px',
    padding: `${isFullFooter ? '16px' : '40px'} 0 16px`,
  },
}));

export const RowItemFooter = ({ children, customstyles, isFullFooter = false }: RowItemFooterProps) => (
  <LicenseStack isFullFooter={isFullFooter} sx={customstyles}>
    {children}
  </LicenseStack>
);
